import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Container, Form, Header, Icon, Modal, Segment, Table } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import api from "./api";
import _ from "lodash";
import Comparison from "../../components/Comparison";
import moment from "moment/moment";

const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    }
};

export function convertPayload(payload) {

    let variations = [];

    if (payload.dimValueID1) {
        variations.push(payload.dimValueID1);
    }
    if (payload.dimValueID2) {
        variations.push(payload.dimValueID2);
    }
    if (payload.dimValueID3) {
        variations.push(payload.dimValueID3);
    }

    if (payload.priceWithVAT) {
        payload.priceWithVat = payload.priceWithVAT;
    }

    if (payload.groupID) {
        payload.group_id = payload.groupID;
    }

    if (payload.supplierID) {
        payload.supplier_id = payload.supplierID;
    }

    if (payload.countryOfOriginID) {
        payload.country_id = payload.countryOfOriginID;
    }

    if (payload.brandID) {
        payload.brand_id = payload.brandID;
    }

    let attributes = {};

    let payloadKeys = Object.keys(payload);
    for (let key in payloadKeys) {
        if (payloadKeys[key].substr(0, 13) === "attributeName") {

            let number = payloadKeys[key].substr(13, payloadKeys[key].length - 13);

            if (attributes["attr" + number]) {
                attributes["attr" + number].name = payload["attributeName" + number];

            } else {
                attributes["attr" + number] = { name: payload["attributeName" + number] };
            }

        } else if (payloadKeys[key].substr(0, 14) === "attributeValue") {
            let number = payloadKeys[key].substr(14, payloadKeys[key].length - 14);

            if (attributes["attr" + number]) {

                attributes["attr" + number].value = payload["attributeValue" + number];

            } else {
                attributes["attr" + number] = { value: payload["attributeValue" + number] };
            }
        }
    }

    payload.product_attributes = Object.values(attributes);

    payload.variations = variations;

    return payload;
}


class ManageProducts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            requests: [],
            activeRequest: null,
            activePayload: false,
            activeRequestId: 0,
            activeComparison: {},
            payloadModalOpen: false,
            confirmationModalOpen: false,
            rejectionModalOpen: false,
            comment: "",
            search: "",
        };
    }


    componentDidMount() {
        this.reloadRequests();
    }

    reloadRequests() {
        api.loadRequests()
            .then((requests) => {
                this.setState({ requests });
            });
    }


    handleSearchChange(e, { value }) {
        this.setState({
            search: value,
        });

    }


    render() {
        console.log(this.state.activePayload);
        const { translate } = this.props;
        const search = this.state.search;

        return <div>

            <Header as='h2' icon textAlign='center'>
                <Icon name='columns' circular/>
            </Header>
            <Header as='h2' color='teal' textAlign='center'>
                {this.props.translate("tools.manageRequests.header")}
            </Header>
            <Container fluid>


                <Segment attached padded>

                    <Form>
                        <Form.Input
                            onChange={_.bind(_.debounce(this.handleSearchChange, 500, { leading: true }), this)}
                            value={this.state.search}
                            label={translate("general.search")}
                        />
                    </Form>

                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.type")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.status")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.creator")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.comment")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.created")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.revised")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.revisedBy")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.revisionComment")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.action")}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {this.state.requests.filter((request) => {

                                if (search === "") {
                                    return true;
                                }

                                for (let key in request) {

                                    if (request[key] && request[key].toString()
                                        .toLowerCase()
                                        .includes(search.toLowerCase())) {
                                        return true;
                                    } else if (request[key] && key === "payload" && JSON.stringify(request[key])
                                        .toLowerCase()
                                        .includes(search.toLowerCase())) {
                                        return true;
                                    } else if (request[key] && key === "comparison" && JSON.stringify(request[key])
                                        .toLowerCase()
                                        .includes(search.toLowerCase())) {
                                        return true;
                                    }
                                }

                                return false;

                            })
                                .map((request, key) =>
                                    <Table.Row key={key}>
                                        <Table.Cell>{translate("tools.manageRequests.type." + request.type)}</Table.Cell>
                                        <Table.Cell>{translate("tools.manageRequests.status." + request.status)}</Table.Cell>
                                        <Table.Cell>{request.creator}</Table.Cell>
                                        <Table.Cell>{request.comment}</Table.Cell>
                                        <Table.Cell>{request.created_at}</Table.Cell>
                                        <Table.Cell>{request.revised_at ? moment.unix(request.revised_at)
                                            .format("YYYY-DD-MM HH:mm:ss") : "-"}</Table.Cell>
                                        <Table.Cell>{request.revisor}</Table.Cell>
                                        <Table.Cell>{request.revisionComment}</Table.Cell>
                                        <Table.Cell>
                                            <Button.Group fluid vertical>
                                                <Button primary onClick={() => {
                                                    this.setState({
                                                        payloadModalOpen: true,
                                                        activePayload: convertPayload(request.payload),
                                                        activeComparison: typeof request.comparison === "object" ? request.comparison : {}
                                                    });
                                                }}>{translate("tools.manageRequests.fields.showDetails")}</Button>
                                                {request.status === "open" &&
                                                <Button positive onClick={() => {
                                                    this.setState({
                                                        confirmationModalOpen: true,
                                                        comment: request.revisionComment,
                                                        activeRequestId: request.id,
                                                    });
                                                }}>Confirm</Button>

                                                }
                                                {request.status === "open" &&

                                                <Button negative onClick={() => {
                                                    this.setState({
                                                        rejectionModalOpen: true,
                                                        comment: request.revisionComment,
                                                        activeRequestId: request.id,
                                                    });
                                                }}>{translate("tools.manageRequests.fields.reject")}</Button>

                                                }
                                            </Button.Group>
                                        </Table.Cell>
                                    </Table.Row>)}
                        </Table.Body>

                    </Table>

                    <Modal
                        size='fullscreen'
                        style={inlineStyle.modal}
                        open={this.state.payloadModalOpen}
                        onClose={() => {
                            this.setState({ payloadModalOpen: false });
                        }}
                    >
                        <Modal.Header>{translate("tools.manageRequests.fields.showDetails")}</Modal.Header>
                        <Modal.Content>
                            <Comparison productIdsReversed={true}
                                        product={this.state.activePayload}
                                        comparison={typeof this.state.activeComparison === "object" ? this.state.activeComparison : {}}/>
                        </Modal.Content>
                    </Modal>


                    <Modal
                        size='fullscreen'
                        style={inlineStyle.modal}
                        open={this.state.confirmationModalOpen}
                        onClose={() => {
                            this.setState({
                                confirmationModalOpen: false,
                                activeRequestId: 0,
                                comment: ""
                            });
                        }}
                    >
                        <Modal.Header>{translate("tools.manageRequests.fields.confirm")}</Modal.Header>
                        <Modal.Content>
                            <Form onSubmit={(e) => {
                                e.preventDefault();
                                api.confirmRequest(this.state.activeRequestId, this.state.comment)
                                    .then(() => {
                                        this.setState({
                                            confirmationModalOpen: false,
                                            activeRequestId: 0,
                                            comment: ""
                                        });

                                        this.reloadRequests();

                                    }, () => {
                                        this.setState({
                                            confirmationModalOpen: false,
                                            activeRequestId: 0,
                                            comment: ""
                                        });

                                        this.reloadRequests();
                                    });
                            }}>
                                <Form.Input
                                    required
                                    maxLength={250}
                                    label={translate("tools.manageRequests.fields.comment")}
                                    value={this.state.comment}
                                    onChange={(e) => {
                                        this.setState({
                                            comment: e.target.value
                                        });
                                    }}
                                />
                                <Button negative
                                        fluid>{translate("tools.manageRequests.fields.confirm")}</Button>
                            </Form>
                        </Modal.Content>
                    </Modal>

                    <Modal
                        size='fullscreen'
                        style={inlineStyle.modal}
                        open={this.state.rejectionModalOpen}
                        onClose={() => {
                            this.setState({
                                rejectionModalOpen: false,
                                activeRequestId: 0,
                                comment: ""
                            });
                        }}
                    >
                        <Modal.Header>{translate("tools.manageRequests.fields.reject")}</Modal.Header>
                        <Modal.Content>
                            <Form onSubmit={(e) => {
                                e.preventDefault();
                                api.rejectRequest(this.state.activeRequestId, this.state.comment)
                                    .then(() => {
                                        this.setState({
                                            rejectionModalOpen: false,
                                            activeRequestId: 0,
                                            comment: ""
                                        });

                                        this.reloadRequests();

                                    }, () => {
                                        this.setState({
                                            rejectionModalOpen: false,
                                            activeRequestId: 0,
                                            comment: ""
                                        });

                                        this.reloadRequests();
                                    });
                            }}>
                                <Form.Input
                                    required
                                    label={translate("tools.manageRequests.fields.comment")}
                                    maxLength={250}
                                    value={this.state.comment}
                                    onChange={(e) => {
                                        this.setState({
                                            comment: e.target.value
                                        });
                                    }}
                                />
                                <Button negative
                                        fluid>{translate("tools.manageRequests.fields.reject")}</Button>
                            </Form>
                        </Modal.Content>
                    </Modal>


                </Segment>
            </Container>
        </div>;
    }


}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManageProducts);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/ManageRequests/index.js